<template>
  <div class="popup-info w-100 p-3" :class="addClass" :style="styleCustom">
    <b-row>
      <b-col v-if="data[name].image && data[name].image[0]" sm="12" md="6" class="text-center ml-auto mr-auto">
        <img :src="`${publicPath}/img/gep/${data[name].image[0]}`" class="mw-100" />
      </b-col>
      <b-col v-if="data[name].image && data[name].image[1]" sm="12" md="6" class="text-center ml-auto mr-auto">
        <img :src="`${publicPath}/img/gep/${data[name].image[1]}`" class="mw-100" />
      </b-col>
      <b-col xl="12" class="mt-3">
        <div class="small fw-700 mb-1">{{ $t(data[name].title) }}</div>
        <ol class="small p-0 pl-3" v-if="data[name].list">
          <li v-for="(item, index) in data[name].list" :key="index" v-html="$t(item)"></li>
        </ol>
      </b-col>
    </b-row>
  </div>
</template>

<script>
const data = {
  license: {
    title: "",
    image: ["business/china/sample-license.png"],
    list: [
      "Please ensure that the text on the image is clearly visible.",
      "The image supports JPG, PNG, and JPEG, and the file is smaller than 4MB.",
    ],
  },
  business_certificate: {
    title: "",
    image: ["business/hongkong/business registration.jpg"],
    list: [
      "Please ensure that the text on the document is clearly visible.",
      "The file supports JPG, PNG, JPEG and PDF, and the file size must be less than 10MB.",
    ],
  },
  annual_return: {
    title: "",
    image: ["business/hongkong/annual return.jpg"],
    list: [
      "Please ensure that the text on the file is clearly visible.",
      "JPG, PNG, JPEG, PDF, RAR, and ZIP are supported and the file is smaller than 20MB.",
      "Company registration must provide an annual return form after one year of registration.",
    ],
  },
  other_accessories: {
    title: "",
    list: [
      "Please ensure that the text on the file is clearly visible.",
      "Please include the following documents:<br><ul><li>Company Ordinance</li><li>Bank Account Certificate</li><li>Business Address Certificate</li></ul>",
      "Please compile all relevant documents in one file.",
      "The file supports JPG, PNG, JPEG, RAR and ZIP",
    ],
  },
  form_incorporation: {
    title: "",
    image: ["business/hongkong/Form of incorporation.jpg"],
    list: [
      "Please ensure that the text on the file is clearly visible.",
      "JPG, PNG, JPEG, PDF, RAR, and ZIP are supported and the file is smaller than 20MB.",
    ],
  },
  certificate_registration: {
    title: "",
    image: ["business/hongkong/Certificate of Registration.jpg"],
    list: [
      "Please ensure that the text on the file is clearly visible.",
      "The image supports JPG, PNG, and JPEG, and the file size is less than 10MB.",
    ],
  },
  equity_structure: {
    title: "",
    list: [
      "Please ensure that the text on the file is clearly visible.",
      "JPG, PNG, JPEG, PDF, RAR, and ZIP are supported and the file is smaller than 20MB.",
    ],
  },
  ic_front: {
    title: "",
    image: ["business/china/ic_front.png"],
    list: [
      "Please ensure that the text on the image is clearly visible.",
      "The image supports JPG, PNG, and JPEG, and the file is smaller than 4MB.",
    ],
  },
  ic_national: {
    title: "",
    image: ["business/china/ic_national.png"],
    list: [
      "Please ensure that the text on the image is clearly visible.",
      "The image supports JPG, PNG, and JPEG, and the file is smaller than 4MB.",
    ],
  },
  ic_holding: {
    title: "",
    image: ["business/china/ic_holding.png"],
    list: [
      "Please ensure that the text on the image is clearly visible.",
      "The image supports JPG, PNG, and JPEG, and the file is smaller than 4MB.",
    ],
  },
  passport_front: {
    title: "",
    image: ["business/china/passport_front.png"],
    list: [
      "Please ensure that the text on the image is clearly visible.",
      "The image supports JPG, PNG, and JPEG, and the file is smaller than 4MB.",
    ],
  },
  passport_holding: {
    title: "",
    image: ["business/china/passport_holding.png"],
    list: [
      "Please ensure that the text on the image is clearly visible.",
      "The image supports JPG, PNG, and JPEG, and the file is smaller than 4MB.",
    ],
  },
  voucher: {
    list: [
      "Please ensure that the file is clearly visible.",
      "The file supports PDF and the file is smaller than 4MB.",
    ],
  },
  beneficiary: {
    title:
      "Beneficiaries include natural persons who directly or indirectly hold more than 25% of the shares; if not, fill in the natural persons who control the company through directors, finance, etc.",
  },
};

export default {
  name: "new-popup-info",
  data() {
    return {
      publicPath: process.env.BASE_URL != "/" ? process.env.BASE_URL : "",
      data: data,
    };
  },
  props: ["name", "addClass", "styleCustom"],
};
</script>
